import { render } from "./ProjectBoardPageGoals.vue?vue&type=template&id=530f5677&ts=true"
import script from "./ProjectBoardPageGoals.vue?vue&type=script&lang=ts"
export * from "./ProjectBoardPageGoals.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__